import { Box } from '@chakra-ui/react';
import MuxVideo from '@mux/mux-video-react';
import * as React from 'react';

import { useCurrent } from '@/hooks/useCurrent';

export const VideoJsPlayer: React.FC<{
  src: string;
  type: string;
  aspectRatio?: { width: number; height: number };
}> = (props) => {
  const current = useCurrent();

  return (
    <Box
      w="full"
      backgroundColor="black"
      sx={{
        aspectRatio: props.aspectRatio
          ? `${props.aspectRatio.width}/${props.aspectRatio.height}`
          : '3/2',
      }}
    >
      <MuxVideo
        style={{
          height: '100%',
          width: '100%',
        }}
        placeholder=""
        src={props.src}
        preload="auto"
        streamType="on-demand"
        preferPlayback="mse"
        metadata={{
          env_key: process.env.NEXT_PUBLIC_MUX_ENV_KEY,
          player_name: 'Tradewing Player',
          viewer_user_id: current.user ? current.user._id : undefined,
        }}
        controls
      />
    </Box>
  );
};
